import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.MatrixPopupContent.MatrixAddUserButton', {
    addAutoApprovalRule: 'Add Auto-Approval Rule',
    addApprover: 'Add an Approver',
    addReviewer: 'Add a Reviewer',
    addRequester: 'Add a Requester',
});
